import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage, useIntl } from 'react-intl';

type ErrorFallbackProps = {
    errorMessage?: string;
    onRetry?: () => void;
};

const ErrorFallback = ({ errorMessage, onRetry }: ErrorFallbackProps) => {
    const intl = useIntl();

    return (
        <ErrorState
            outerClassName='margin-top-20'
            headline={intl.formatMessage({
                id: 'intl-msg:common-message.error.generic.headline',
            })}
            message={
                <>
                    {intl.formatMessage({
                        id: 'intl-msg:common-message.error.generic.message',
                    })}
                    {errorMessage && <div className='margin-top-15 text-color-dark'>{errorMessage}</div>}
                </>
            }
            buttons={
                onRetry
                    ? [
                          {
                              onClick: onRetry,
                              text: <FormattedMessage id='intl-msg:common-message.error.generic.retry' />,
                          },
                      ]
                    : undefined
            }
        />
    );
};

export default ErrorFallback;
